<div class="location-meters flex-column">
    <div class="field-grid add-meter-row" style="margin-bottom: 1rem;">
        <label class="input outlined" [title]="'METERS.SERIAL' | trans">
            <input [(ngModel)]="new_serial" />
        </label>

        <label class="input outlined" [title]="'METERS.BRAND' | trans">
            <input [(ngModel)]="new_brand" />
        </label>

        <label class="input outlined" [title]="'METERS.TYPE' | trans">
            <select [(ngModel)]="new_type_id">
                <option [ngValue]="null" disabled>—</option>
                <option *ngFor="let t of meter_types" [ngValue]="t.meter_type_id">{{ t.name }}</option>
            </select>
        </label>

        <div class="flex-row whole-row align-center wrappable" style="gap:.5rem;">
            <span class="flex-dynamic"></span>
            <button (click)="add_meter()" class="flex-static pill"
                [disabled]="!new_serial.trim() || !new_brand.trim() || !new_type_id">
                <i icon="add_circle"></i>
                <span>{{ 'ADD' | trans }}</span>
            </button>
        </div>
    </div>

    <ng-container *ngIf="!location?.location_id">
        <div *ngIf="pending_meters.length === 0" class="empty-state flex-row align-center justify-center">
            <i icon="info"></i>&nbsp;{{ 'METERS.WILL_SAVE_WITH_LOCATION' | trans }}
        </div>

        <div *ngFor="let p of pending_meters; let i = index" class="meter-card pending-meter flex-row align-center">
            <span class="meter-type-ic" [style.color]="type_color(p.type_name)">
                <i [attr.icon]="type_icon(p.type_name)"></i>
            </span>
            <span class="meter-id flex-column">
                <b>{{ p.code }}</b>
                <span class="meter-brand">{{ p.brand }}<ng-container *ngIf="p.type_name"> · {{ p.type_name }}</ng-container></span>
            </span>
            <span class="flex-dynamic"></span>
            <button class="round" color="warn" (click)="remove_pending(i)" [title]="'DELETE' | trans">
                <i icon="clear"></i>
            </button>
        </div>
    </ng-container>

    <ng-container *ngIf="location?.location_id">

        <div *ngIf="meters.length === 0" class="flex-row align-center justify-center empty-state">
            {{ 'METERS.NO_METERS' | trans }}
        </div>

        <details *ngFor="let m of meters; trackBy: track_meter" class="details-card meter-card"
            (toggle)="handle_toggle(m, $event)">
            <summary class="meter-head flex-row align-center">

                <span class="meter-type-ic" [style.color]="type_color(m.meter_type_name)">
                    <i [attr.icon]="type_icon(m.meter_type_name)" [attr.tooltip-right]="m.meter_type_name"></i>
                </span>

                <span class="meter-id flex-column">
                    <b>{{ m.code }}</b>
                    <span class="meter-brand">{{ m.brand }}</span>
                </span>

                <span class="flex-dynamic"></span>

                <i class="meter-recorded" [class.is-recorded]="is_recorded(m)"
                    [attr.icon]="is_recorded(m) ? 'check_circle' : 'remove'"
                    [attr.tooltip-left]="(is_recorded(m) ? 'METERS.RECORDED' : 'METERS.NOT_RECORDED') | trans"></i>

            </summary>

            <div class="meter-body">
                <div class="readings-head flex-row align-center wrappable">
                    <h4>{{ 'METERS.READINGS' | trans }}</h4>
                    <span class="from-mobile">{{ 'METERS.FROM_MOBILE' | trans }}</span>
                </div>

                <div *ngIf="state_of(m).loading" class="no-readings flex-row align-center justify-center">
                    <knw-spinner color="primary" size="24"></knw-spinner>
                </div>

                <div *ngIf="state_of(m).loaded && state_of(m).readings.length === 0" class="no-readings">
                    {{ 'METERS.NO_READINGS' | trans }}
                </div>

                <div class="readings-table" *ngIf="state_of(m).readings.length"
                    [style.--cols]="m.measures?.length || 1">

                    <div *ngFor="let g of state_of(m).readings; trackBy: track_reading"
                        class="readings-row reading-card">
                        <span class="col date"><i icon="event"></i>{{ g.timestamp | datefmt : 'short_date' : false }}</span>

                        <span class="col val" *ngFor="let ms of m.measures">
                            <label>{{ ms.name }}<ng-container *ngIf="ms.unit">&nbsp;({{ ms.unit }})</ng-container></label>
                            <span class="value-row flex-row align-center">
                                <span class="value">{{ measure_value(g, ms.meter_type_measure_id) }}</span>
                                <span class="delta" *ngIf="g.deltas[ms.meter_type_measure_id] != null"
                                    [class.down]="g.deltas[ms.meter_type_measure_id] < 0">
                                    <i [attr.icon]="g.deltas[ms.meter_type_measure_id] < 0 ? 'arrow_downward' : 'arrow_upward'"></i>{{ delta_abs(g.deltas[ms.meter_type_measure_id]) }}
                                </span>
                            </span>
                        </span>

                        <span class="col imgs">
                            <span *ngIf="g.images.length" class="photo-btn flex-row align-center"
                                [title]="'METERS.PHOTO' | trans" (click)="open_images(g)">
                                <i icon="image"></i>
                                <span *ngIf="g.images.length > 1" class="more">+{{ g.images.length - 1 }}</span>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </details>

    </ng-container>
</div>
